var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCooldownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 5.67334V9.42334L12.375 12.4233",
    stroke: "#08A98A",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.59948 1.27087L2.05273 5.61862L6.32173 4.42912",
    stroke: "#08A98A",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.05275 5.61861C2.98215 3.8282 4.53532 2.44035 6.41861 1.71746C8.3019 0.994573 10.3848 0.986752 12.2735 1.69547C14.1621 2.4042 15.7257 3.78034 16.6685 5.56373C17.6113 7.34711 17.868 9.41413 17.3902 11.374C16.9123 13.3338 15.7329 15.0506 14.075 16.1999C12.4171 17.3491 10.3956 17.8511 8.39265 17.6109C6.38974 17.3707 4.54424 16.4049 3.20509 14.8963C1.86593 13.3876 1.12593 11.4406 1.125 9.42336",
    stroke: "#08A98A",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.0483398)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCooldownIcon);
export default __webpack_public_path__ + "static/media/cooldownIcon.e30f5c8b22e65a863912d3f3409d57c3.svg";
export { ForwardRef as ReactComponent };